import { createSlice } from '@reduxjs/toolkit';
import { ParticipantState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { getParticipantThunk } from './thunks';

// Initial State
const initialState: ParticipantState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const participantSlice = createSlice({
  name: 'participant',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getParticipantThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });

    builder.addCase(getParticipantThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });

    builder.addCase(getParticipantThunk.rejected.type, (state, { payload }: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset } = participantSlice.actions;
export * from './thunks';
export * from './selectors';
export * from './types';
export default participantSlice.reducer;
